import { urls } from './appUrls';

/** Routes reachable without a backend access token (login / password recovery). */
export const PUBLIC_AUTH_PATHS = [urls.loginSuperAdmin, urls.recoveryPassword, urls.resetPassword] as const;

export const isPublicAuthPath = (pathname: string): boolean =>
	PUBLIC_AUTH_PATHS.some(path => pathname === path || pathname.startsWith(`${path}/`));
